<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90 section-space--pb_40">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-3 col-md-4 footer-widget text-center text-md-left">
                        <div class="footer-widget__logo">
                            <router-link to="/">
                                <!-- <img src="@/assets/static-img/logo/logo-dark.png" class="img-fluid logo-dark" alt="logo">
                                <img src="@/assets/static-img/logo/logo-light.png" class="img-fluid logo-light" alt="logo"> -->
                                <logo class="w-48 fill-current text-primary" />
                                <!-- <span class="vx-logo-text">QuickSend</span> -->
                            </router-link>
                        </div>
                    </div>
                    <div class="col-lg-9 col-md-8 footer-widget text-center text-md-right">
                        <!-- <h6 class="footer-widget__title mb-2">Contact Us</h6>
                        <p>Have some questions? We're here to help.
                        <div>
                            <form class="input-group">
                                <div class="row">
                                    <div class="col-md-6">
                                        <input type="text" placeholder="Your Name" class="form-control mb-2">
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" placeholder="Your Email" class="form-control mb-2">
                                    </div>
                                    <div class="col-md-12">
                                        <textarea type="text" placeholder="Your Message" class="form-control mb-2" />
                                    </div>
                                </div>
                            </form>
                        </div> -->
                        <!--<router-link to="/faq" class="hover-style-link px-3 d-block d-md-inline-block">FAQ</router-link> <span class="d-none d-md-inline">|</span>--> <router-link to="/tnc" class="hover-style-link px-3 d-block d-md-inline-block">Terms and Condition</router-link> <span class="d-none d-md-inline">|</span> <router-link to="/privacy-policy" class="hover-style-link px-3 d-block d-md-inline-block">Privacy Policy</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-8 text-center text-md-left">
                        <p class="copyright-text">
                            <span>COPYRIGHT &copy;</span>
                            <span>{{ new Date().getFullYear() }} </span>
                            <a href="/" target="_blank" rel="nofollow">QuickSend</a>
                            <span class="hidden sm:inline-block">, All Rights Reserved.</span>
                        </p>
                    </div>
                    <!-- <div class="col-12 text-center">
                        <p class="copyright-text">
                            <span>COPYRIGHT &copy;</span>
                            <span>{{ new Date().getFullYear() }} </span>
                            <a href="/" target="_blank" rel="nofollow">QuickSend</a>
                            <span class="hidden sm:inline-block">, All Rights Reserved.</span>
                        </p>
                    </div> -->
                    <div class="col-md-4 text-center text-md-right">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.facebook.com/QuickSend.asia" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://www.instagram.com/QuickSend.asia" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'
    export default {
        components: {
            Logo
        },
        name: 'FooterMain',
        props: ["FooterStyle"]
    }

    
</script>